// ABOUTME: Route wrapper that reads :slug from the URL and mounts ModuleHost
// ABOUTME: Handles the missing-slug edge before delegating to the loader

import { useParams } from 'react-router-dom';
import { ModuleErrorCard } from './ModuleErrorCard';
import { ModuleHost } from './ModuleHost';

export function ModuleHostRoute() {
  const { slug } = useParams<{ slug: string }>();
  if (!slug) return <ModuleErrorCard slug="(missing)" message="No module slug in route" />;
  return <ModuleHost slug={slug} />;
}
